import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Cheque } from '../../models/cheque';
import { BancoService } from '../../services/banco.service';
import { Banco } from '../../models/banco';
import { Validation } from '../../config/validation';
import { Tarjeta } from '../../models/tarjeta';
import { TipoTarjetaService } from '../../services/tipo-tarjeta.service';
import { TipoTarjeta } from '../../models/tipo-tarjeta';
import { DatosAdicionales } from '../../models/datos-adicionales';
import * as moment from 'moment';
import { Transferencia } from '../../models/transferencia';

@Component({
	selector: 'datos-pago',
	templateUrl: './datos-pago.component.html',
    styleUrls: ['./datos-pago.component.css'],
    providers: [BancoService, TipoTarjetaService]
})
export class DatosPagosComponent implements OnInit {
    public vl: Validation;
    public modalRef: BsModalRef;
    public bancos: Array<Banco>;
    public tipos_tarjetas: Array<TipoTarjeta>;
    @Input() tipo_pago: String;
    @Input()compra: String;
    @Input() venta: String;
    @Input() tipo_actividad: String;
    @Input() public cheques: Array<Cheque>;
    @Input() public tarjetas: Array<Tarjeta>;
    @Input() public transferencias: Array<Transferencia>;
    @Input() public valorefectivo: number;
    @Input() public numero_decimales: number = 2;
    @Output() public onChangeTotal = new EventEmitter();
    @Output() public onChangeEfectivo = new EventEmitter();

    //totales
    public total_cheque: number = 0;
    public total_tarjeta: number = 0;
    public total_efectivo: number = 0;
    public total_transferencia: number = 0;

    public cheque: Cheque;
    public tarjeta: Tarjeta;
    public loading: boolean;
    public transferencia: Transferencia;

    public format_decimal: String;

	constructor(
        private modalService: BsModalService,
        private bancoService: BancoService,
        private tipoTarjetaService: TipoTarjetaService
    ) {
        this.loading = false;
        this.cheque = new Cheque();
        this.transferencia = new Transferencia();
        //this.cheque.fecha = this.initDate();
        let now = moment();
        this.cheque.fecha = moment(now.format(), moment.ISO_8601).format();
        this.transferencia.fecha = moment(now.format(),moment.ISO_8601).format();
        this.bancos = [];
        this.tarjeta = new Tarjeta();
        this.valorefectivo = 0;
        this.tipos_tarjetas = [];
        this.format_decimal = "0,0.00";
        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];
        this.valorefectivo = 0;
    }

	ngOnInit() {
        this.setFormat();
        this.vl = new Validation();
        let p1 = this.getBancos();
        let p2 = this.getTiposTarjeta();

        this.loading = true;
        Promise.all([p1, p2]).then(
            res => {
                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    isCheckedTipo(){
        if (this.compra || this.venta) {
            if (this.tipo_pago != "CO" ) {
                this.total_efectivo= 0;
                this.total_cheque = 0;
                this.total_tarjeta = 0;
                this.total_transferencia = 0;
                return true;
            }
        }
        
        return false;
    }

    setFormat(){
        let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
        this.format_decimal = "0,0." + digitos
    }

    getBancos(){
        return new Promise((resolve, reject) => {
            this.bancoService.getAll().subscribe(
                res => {
                    this.bancos = res.data;
                    resolve();
                },
                err => {
                    this.bancos = [];
                    reject(err);
                }
            );
        });
    }

    getTiposTarjeta(){
        return new Promise((resolve, reject) => {
            this.tipoTarjetaService.getAll().subscribe(
                res => {
                    this.tipos_tarjetas = res.data;
                    resolve();
                },
                err => {
                    this.tipos_tarjetas = [];
                    reject(err);
                }
            );
        });
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
    }

    addCheque(){
        this.cheques.push(this.cheque);
        this.cheque = new Cheque();
        let now = moment();
        this.cheque.fecha = moment(now.format(), moment.ISO_8601).format();
        this.setTotal();
    }

    addTransferencia(){
     
        this.transferencias.push(this.transferencia);
        this.transferencia = new Transferencia();
        let now = moment();
        this.transferencia.fecha = moment(now.format(), moment.ISO_8601).format();
        this.setTotal();
    }

    addTarjeta(){
        this.tarjetas.push(this.tarjeta);
        this.tarjeta = new Tarjeta();
        this.setTotal();
    }    

    addEfectivo(){
        //this.valorefectivo = valor;
        //
        this.setTotal();
        this.onChangeEfectivo.emit(this.valorefectivo);
    }

    setTotal(){
        this.total_cheque = 0;
        
        this.cheques.forEach(x => this.total_cheque += parseFloat(x.valor.toString()));
        if( this.total_efectivo.toString() === "" ) this.total_efectivo = 0;
        
        this.total_tarjeta = 0;    
        
        this.tarjetas.forEach(x => this.total_tarjeta += parseFloat(x.valor.toString()));
        if( this.total_efectivo.toString() === "" ) this.total_efectivo = 0;

        this.total_transferencia = 0;
        this.transferencias.forEach(tr=> this.total_transferencia += parseFloat(tr.valor.toString()));
        if( this.total_efectivo.toString() === "" ) this.total_efectivo = 0;

        
        this.total_efectivo = this.valorefectivo;
        if( this.total_efectivo.toString() === "" ) this.total_efectivo = 0;

        //Emit
        let total = parseFloat(this.total_cheque.toString()) + parseFloat(this.total_tarjeta.toString())+parseFloat(this.total_transferencia.toString()) + parseFloat(this.total_efectivo.toString());
        this.onChangeTotal.emit(total);
        
    }

    onDelete(i){
        this.cheques.splice(i, 1);
        this.setTotal();
    }

    onDeleteTarjeta(i){
        this.tarjetas.splice(i, 1);
        this.setTotal();
    }

    onDeleteTransferencia(i){
        this.transferencias.splice(i,1);
        this.setTotal();
    }

    onChangeBancoCheque(){
        this.cheque.banco = this.bancos.filter(b => b.id.toString() === this.cheque.banco_id.toString())[0];
    }

    onChangeBancoTransferencia(){
        this.transferencia.banco = this.bancos.filter(b => b.id.toString() === this.transferencia.banco_id.toString())[0];
    }

    /*onChangeBancoTarjeta(){
        this.tarjeta.banco = this.bancos.filter(b => b.id.toString() === this.tarjeta.banco_id.toString())[0];
    }*/

    onChangeTipo(){
        this.tarjeta.tipo = this.tipos_tarjetas.filter(b => b.id.toString() === this.tarjeta.tipo_id.toString())[0];
    }

    isDebitoCredito(debito_credito){
        return (debito_credito=="D"?"DEBITO":"CREDITO");
    }

    isChequeFormValid(){
        if( this.cheque.fecha.toString().trim().length === 0 ){
            return false;
        }
        if( this.cheque.banco_id === "" ){
            return false;
        }
        if( this.cheque.cuenta.trim() === "" ){
            return false;
        }
        if( this.cheque.numero.trim() === "" ){
            return false;
        }
        if( this.cheque.valor.toString() === "" || this.cheque.valor <= 0){
            return false;
        }
        return true;
    }

    isTarjetaValidForm(){
        if( this.tarjeta.debito_credito === "" ){
            return false;
        }
        if( this.tarjeta.tipo_id === "" ){
            return false;
        }
        /*if( this.tarjeta.banco_id === "" ){
            return false;
        }*/
        if( this.tarjeta.valor.toString() === "" || this.tarjeta.valor <= 0){
            return false;
        }
        if( this.tarjeta.plazo.toString().trim().length <= 0 ){
            return false;
        }
        if( this.tarjeta.tiempo.toString().trim().length <= 0 ){
            return false;
        }
        return true;
    }

    isTransferenciaFormValid(){
        if( this.transferencia.fecha.toString().trim().length === 0 ){
            return false;
        }
        if( this.transferencia.banco_id === "" ){
            return false;
        }
        if( this.transferencia.cuenta.trim() === "" ){
            return false;
        }
        if( this.transferencia.numero.trim() === "" ){
            return false;
        }
        if( this.transferencia.valor.toString() === "" || this.transferencia.valor <= 0){
            return false;
        }
        return true;
    }

    initDate(){
		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; //January is 0!
		let dia = "";
		let mes = "";

		var yyyy = today.getFullYear();
		dia = "" + dd;
		mes = "" + mm;
		if (dd < 10) {
			dia = "0" + dd;
		}
		if (mm < 10) {
			mes = "0" + mm;
		}
		let today2 = dia + '/' + mes + '/' + yyyy;
        return today2;
    }

    get formatDecimal(){
        return this.format_decimal;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/datos-pago/datos-pago.component.ts